"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessToken = getAccessToken;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function noop() {}

var propTypes = {
  // Creation parameters
  container: _propTypes.default.object,

  /** The container to have the map. */
  mapboxApiAccessToken: _propTypes.default.string,

  /** Mapbox API access token for Mapbox tiles/styles. */
  attributionControl: _propTypes.default.bool,

  /** Show attribution control or not. */
  preserveDrawingBuffer: _propTypes.default.bool,

  /** Useful when you want to export the canvas as a PNG. */
  onLoad: _propTypes.default.func,

  /** The onLoad callback for the map */
  onError: _propTypes.default.func,

  /** The onError callback for the map */
  reuseMaps: _propTypes.default.bool,
  reuseMap: _propTypes.default.bool,
  transformRequest: _propTypes.default.func,

  /** The transformRequest callback for the map */
  mapStyle: _propTypes.default.string,

  /** The Mapbox style. A string url to a MapboxGL style */
  visible: _propTypes.default.bool,

  /** Whether the map is visible */
  // Map view state
  width: _propTypes.default.number,

  /** The width of the map. */
  height: _propTypes.default.number,

  /** The height of the map. */
  viewState: _propTypes.default.object,

  /** object containing lng/lat/zoom/bearing/pitch */
  longitude: _propTypes.default.number,

  /** The longitude of the center of the map. */
  latitude: _propTypes.default.number,

  /** The latitude of the center of the map. */
  zoom: _propTypes.default.number,

  /** The tile zoom level of the map. */
  bearing: _propTypes.default.number,

  /** Specify the bearing of the viewport */
  pitch: _propTypes.default.number,

  /** Specify the pitch of the viewport */
  // Note: Non-public API, see https://github.com/mapbox/mapbox-gl-js/issues/1137
  altitude: _propTypes.default.number,

  /** Altitude of the viewport camera. Default 1.5 "screen heights" */
  mapOptions: _propTypes.default.object
  /** Extra options to pass to Mapbox constructor. See #545. **/

};
var defaultProps = {
  mapboxApiAccessToken: getAccessToken(),
  preserveDrawingBuffer: false,
  attributionControl: true,
  preventStyleDiffing: false,
  onLoad: noop,
  onError: noop,
  reuseMaps: false,
  reuseMap: false,
  transformRequest: null,
  mapStyle: 'mapbox://styles/mapbox/light-v8',
  visible: true,
  bearing: 0,
  pitch: 0,
  altitude: 1.5,
  width: 0,
  height: 0,
  mapOptions: {}
}; // Try to get access token from URL, env, local storage or config

function getAccessToken() {
  var accessToken = null;

  if (typeof window !== 'undefined' && window.location) {
    var match = window.location.search.match(/access_token=([^&\/]*)/);
    accessToken = match && match[1];
  }

  if (!accessToken && typeof process !== 'undefined') {
    // Note: This depends on bundler plugins (e.g. webpack) inmporting environment correctly
    accessToken = accessToken || process.env.MapboxAccessToken; // eslint-disable-line
  }

  return accessToken || null;
} // Helper function to merge defaultProps and check prop types


function checkPropTypes(props) {
  var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'component';

  // TODO - check for production (unless done by prop types package?)
  if (props.debug) {
    _propTypes.default.checkPropTypes(propTypes, props, 'prop', component);
  }
} // A small wrapper class for mapbox-gl
// - Provides a prop style interface (that can be trivially used by a React wrapper)
// - Makes sure mapbox doesn't crash under Node
// - Handles map reuse (to work around Mapbox resource leak issues)
// - Provides support for specifying tokens during development


var Mapbox =
/*#__PURE__*/
function () {
  function Mapbox(props) {
    _classCallCheck(this, Mapbox);

    if (!props.mapboxgl) {
      throw new Error('Mapbox not available');
    }

    if (!Mapbox.initialized && console.debug) {
      // eslint-disable-line
      Mapbox.initialized = true; // Version detection using babel plugin

      /* global __VERSION__ */

      var VERSION = typeof "3.3.4" !== 'undefined' ? "3.3.4" : 'untranspiled source';
      console.debug("react-map-gl: ".concat(VERSION, " using mapbox-gl v").concat(props.mapboxgl.version)); // eslint-disable-line
    }

    this.props = {};

    this._initialize(props);
  }

  _createClass(Mapbox, [{
    key: "finalize",
    value: function finalize() {
      this._destroy();

      return this;
    }
  }, {
    key: "setProps",
    value: function setProps(props) {
      this._update(this.props, props);

      return this;
    } // Mapbox's map.resize() reads size from DOM, so DOM element must already be resized
    // In a system like React we must wait to read size until after render
    // (e.g. until "componentDidUpdate")

  }, {
    key: "resize",
    value: function resize() {
      this._map.resize();

      return this;
    } // External apps can access map this way

  }, {
    key: "getMap",
    value: function getMap() {
      return this._map;
    } // PRIVATE API

  }, {
    key: "_create",
    value: function _create(props) {
      // Reuse a saved map, if available
      if ((props.reuseMaps || props.reuseMap) && Mapbox.savedMap) {
        this._map = this.map = Mapbox.savedMap; // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step1: reparenting child nodes from old container to new container

        var oldContainer = this._map.getContainer();

        var newContainer = props.container;
        newContainer.classList.add('mapboxgl-map');

        while (oldContainer.childNodes.length > 0) {
          newContainer.appendChild(oldContainer.childNodes[0]);
        } // Step2: replace the internal container with new container from the react component


        this._map._container = newContainer;
        Mapbox.savedMap = null; // Update style

        if (props.mapStyle) {
          this._map.setStyle(props.mapStyle);
        } // TODO - need to call onload again, need to track with Promise?


        props.onLoad();
      } else {
        var mapOptions = {
          container: props.container || document.body,
          center: [0, 0],
          zoom: 8,
          pitch: 0,
          bearing: 0,
          style: props.mapStyle,
          interactive: false,
          attributionControl: props.attributionControl,
          preserveDrawingBuffer: props.preserveDrawingBuffer
        }; // We don't want to pass a null or no-op transformRequest function.

        if (props.transformRequest) {
          mapOptions.transformRequest = props.transformRequest;
        }

        this._map = this.map = new props.mapboxgl.Map(Object.assign({}, mapOptions, props.mapOptions)); // Attach optional onLoad function

        this.map.once('load', props.onLoad);
        this.map.on('error', props.onError);
      }

      return this;
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      if (!this._map) {
        return;
      }

      if (!Mapbox.savedMap) {
        Mapbox.savedMap = this._map;
      } else {
        this._map.remove();
      }

      this._map = null;
    }
  }, {
    key: "_initialize",
    value: function _initialize(props) {
      props = Object.assign({}, defaultProps, props);
      checkPropTypes(props, 'Mapbox'); // Make empty string pick up default prop

      this.accessToken = props.mapboxApiAccessToken || defaultProps.mapboxApiAccessToken; // Creation only props

      if (props.mapboxgl) {
        if (!this.accessToken) {
          props.mapboxgl.accessToken = 'no-token'; // Prevents mapbox from throwing
        } else {
          props.mapboxgl.accessToken = this.accessToken;
        }
      }

      this._create(props); // Disable outline style


      var canvas = this.map.getCanvas();

      if (canvas) {
        canvas.style.outline = 'none';
      }

      this._updateMapViewport({}, props);

      this._updateMapSize({}, props);

      this.props = props;

      this._checkStyleSheet();
    }
  }, {
    key: "_update",
    value: function _update(oldProps, newProps) {
      if (!this._map) {
        return;
      }

      newProps = Object.assign({}, this.props, newProps);
      checkPropTypes(newProps, 'Mapbox');

      this._updateMapViewport(oldProps, newProps);

      this._updateMapSize(oldProps, newProps);

      this.props = newProps;
    } // Note: needs to be called after render (e.g. in componentDidUpdate)

  }, {
    key: "_updateMapSize",
    value: function _updateMapSize(oldProps, newProps) {
      var sizeChanged = oldProps.width !== newProps.width || oldProps.height !== newProps.height;

      if (sizeChanged) {
        this._map.resize();
      }
    }
  }, {
    key: "_updateMapViewport",
    value: function _updateMapViewport(oldProps, newProps) {
      var oldViewState = this._getViewState(oldProps);

      var newViewState = this._getViewState(newProps);

      var viewportChanged = newViewState.latitude !== oldViewState.latitude || newViewState.longitude !== oldViewState.longitude || newViewState.zoom !== oldViewState.zoom || newViewState.pitch !== oldViewState.pitch || newViewState.bearing !== oldViewState.bearing || newViewState.altitude !== oldViewState.altitude;

      if (viewportChanged) {
        this._map.jumpTo(this._getMapboxViewStateProps(newProps)); // TODO - jumpTo doesn't handle altitude


        if (newViewState.altitude !== oldViewState.altitude) {
          this._map.transform.altitude = newViewState.altitude;
        }
      }
    }
  }, {
    key: "_getViewState",
    value: function _getViewState(props) {
      var _ref = props.viewState || props,
          longitude = _ref.longitude,
          latitude = _ref.latitude,
          zoom = _ref.zoom,
          _ref$pitch = _ref.pitch,
          pitch = _ref$pitch === void 0 ? 0 : _ref$pitch,
          _ref$bearing = _ref.bearing,
          bearing = _ref$bearing === void 0 ? 0 : _ref$bearing,
          _ref$altitude = _ref.altitude,
          altitude = _ref$altitude === void 0 ? 1.5 : _ref$altitude;

      return {
        longitude: longitude,
        latitude: latitude,
        zoom: zoom,
        pitch: pitch,
        bearing: bearing,
        altitude: altitude
      };
    }
  }, {
    key: "_checkStyleSheet",
    value: function _checkStyleSheet() {
      if (typeof document === 'undefined') {
        return;
      } // check mapbox styles


      try {
        var missingCssWarning = document.querySelector('.mapboxgl-missing-css');
        var isCssLoaded = window.getComputedStyle(missingCssWarning).display === 'none';

        if (!isCssLoaded) {
          // attempt to insert mapbox stylesheet
          var mapboxVersion = this.props.mapboxgl.version;
          var link = document.createElement('link');
          link.setAttribute('rel', 'stylesheet');
          link.setAttribute('type', 'text/css');
          link.setAttribute('href', "https://api.tiles.mapbox.com/mapbox-gl-js/v".concat(mapboxVersion, "/mapbox-gl.css"));
          document.head.append(link);
        }
      } catch (error) {// do nothing
      }
    }
  }, {
    key: "_getMapboxViewStateProps",
    value: function _getMapboxViewStateProps(props) {
      var viewState = this._getViewState(props);

      return {
        center: [viewState.longitude, viewState.latitude],
        zoom: viewState.zoom,
        bearing: viewState.bearing,
        pitch: viewState.pitch,
        width: props.width,
        height: props.height
      };
    }
  }]);

  return Mapbox;
}();

exports.default = Mapbox;
Mapbox.propTypes = propTypes;
Mapbox.defaultProps = defaultProps;
//# sourceMappingURL=mapbox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/es5/mapbox/mapbox.js
// module id = 552
// module chunks = 35783957827783